import {
  CountsByParallels,
  Participants,
  ParticipantsBase,
  ParticipantsSampleForMunicipality,
  ParticipantsSampleForRegion,
  StudentsRowProps,
  Subject,
  Test,
  TestRound,
} from 'features/monitoring/models';
import { useMemo } from 'react';

import { collectRows } from 'features/monitoring/collectRows';

function getNewSchoolRow(sample: ParticipantsSampleForMunicipality): StudentsRowProps {
  return {
    school: sample.school_name,
    location: sample.school_location,
    studentCounts: {},
    noResults: true,
  };
}

function getNewMunicipalityRow(sample: ParticipantsSampleForRegion): StudentsRowProps {
  return {
    school: '',
    location: sample.municipality_name,
    studentCounts: {},
    noResults: true,
  };
}

function updateStudentsCount(school: StudentsRowProps, sample: ParticipantsBase) {
  school.studentCounts[sample.parallel] = sample.tested_students_count;
  if (!!sample.tested_students_count) {
    school.noResults = false;
  }
}

function getRows(
  samples: ParticipantsSampleForMunicipality[] | ParticipantsSampleForRegion[],
  isRegion: boolean,
  targetTestId: number,
): StudentsRowProps[] {
  if (isRegion) {
    return collectRows(
      samples as ParticipantsSampleForRegion[],
      (sample) => sample.test_id === targetTestId,
      getNewMunicipalityRow,
      (sample) => sample.municipality_id,
      updateStudentsCount,
    );
  } else {
    return collectRows(
      samples as ParticipantsSampleForMunicipality[],
      (sample) => sample.test_id === targetTestId,
      getNewSchoolRow,
      // TODO: Временные составные идентификаторы для школ
      // Когда в KnowledgeMonitoringApi.getTestParticipantsForMunicipality() добавят schoolId сделать тут return sample.school_id
      (sample) => sample.school_name + ' ' + sample.school_location,
      updateStudentsCount,
    );
  }
}

function getTotal(total: ParticipantsBase[], targetTestId: number) {
  const totalSamples = total.filter((sample) => sample.test_id === targetTestId);
  const result: CountsByParallels = {};

  totalSamples.forEach((sample) => {
    result[sample.parallel] = sample.tested_students_count;
  });
  return result;
}

export const useStudentTableProps = (
  isRegion: boolean,
  tests: Test[],
  subject: Subject,
  testRound: TestRound,
  participants: Participants | undefined,
) => {
  return useMemo(() => {
    if (!participants || !tests || !participants.participants_data || !participants.total) {
      return null;
    }

    const targetTestId = tests.find((test) => test.subject === subject && test.test_name === testRound)?.test_id;

    if(!targetTestId) {
      return {
        total: {},
        rows: [],
      }
    }

    const total = getTotal(participants.total, targetTestId);
    let rows = getRows(participants.participants_data, isRegion, targetTestId);

    return {
      total,
      rows,
    };
  }, [tests, participants, subject, testRound]);
};
